/*
 * BadgeRole Messages
 *
 * This contains all the strings for the BadgeRole component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  // Merchant citizen role tooltip message
  roleM: `Merchant`,
  // Retailer citizen role tooltip message
  roleR: `Retailer`,
  // Wholesaler citizen role tooltip message
  roleW: `Wholesaler`,
});
